import React from "react";

function Services() {
  return (
    <section className="section" id="services">
      <div className="container">
        <div className="tiles-grid tiles-grid-four">
          <div className="tile link-tile" id="services-tile">
            <h3>Services</h3>
            <p>
              IT consultancy, web &amp; mobile app development, cloud, DevOps, IoT & Embedded Solutions
              and AI automation .
            </p>
          </div>
          <div className="tile link-tile" id="industries">
            <h3>Industries</h3>
            <p>
              Fintech, SaaS, e-commerce, healthtech and data-driven
              enterprises.
            </p>
          </div>
          <div className="tile link-tile" id="case-studies">
            <h3>Case studies</h3>
            <p>
              Projects where we scaled teams and delivered measurable outcomes.
            </p>
          </div>
          <div className="tile link-tile" id="careers">
            <h3>Careers</h3>
            <p>
              Join Vuzenik and work with global teams on ambitious modern
              products.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
